import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function updateProfileMe(userData) {
  const response = await apiRequest({
    method: "patch",
    path: "/profile/me",
    data: userData,
    errorMessage: "Erro ao atualizar seus dados",
  });

  return unwrapProfileResponse(response);
}
